export const prepareGameConfigurationSubmission = (
    values: any,
    isEdit: boolean
) => {
    const configuration = {...values};
    configuration.use_main_logo = configuration.use_main_logo !== false;

    if (
        !configuration.use_main_logo &&
        configuration.image_base64 &&
        (!isEdit || configuration.image_base64 !== "previous")
    ) {
        configuration.file = configuration.image_base64;
    }

    delete configuration.image_base64;
    delete configuration.image;

    return configuration;
};

export const buildGameConfigurationPayload = (
    configuration: any,
    gameId: number
) => {
    const configurationSettings = {...configuration};
    const file = configurationSettings.file;
    const useMainLogo = configurationSettings.use_main_logo !== false;

    delete configurationSettings.file;
    delete configurationSettings.use_main_logo;

    return {
        game_id: gameId,
        subsidiary: configurationSettings.subsidiary,
        label: configurationSettings.label,
        game_category_id: configurationSettings.game_category_id || null,
        use_main_logo: useMainLogo,
        configuration: configurationSettings,
        ...(file ? {file} : {})
    };
};

export const serializeGameConfigurationPayload = (configuration: any) => ({
    ...configuration,
    configuration: JSON.stringify(configuration.configuration)
});
